import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Composant {
  id: number;
  nom: string;
  lien: string | null;
  photo: string | null;
  prix: number | null;
  standard_emballage: string | null;
  unite: string | null;
  ref_fabricant: string | null;
  commentaire: string | null;
  classe_id: number | null;
  classe_nom: string | null;
}

export interface ComposantPayload {
  nom: string;
  lien: string;
  prix: number | null;
  standard_emballage: string;
  unite: string;
  ref_fabricant: string;
  commentaire: string;
  classe_id: string;
  photo?: string;
}

@Injectable({ providedIn: 'root' })
export class ComposantsService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/composants`;
  private readonly requestTimeoutMs = 30000;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<Composant[]> {
    return this.http
      .get<{ items?: Composant[] } | Composant[]>(this.baseUrl)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          return Array.isArray(response?.items) ? response.items : [];
        })
      );
  }

  getById(id: number): Observable<Composant> {
    return this.http
      .get<Composant>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }

  create(payload: ComposantPayload): Observable<Composant> {
    return this.http
      .post<Composant>(this.baseUrl, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  update(id: number, payload: ComposantPayload): Observable<Composant> {
    return this.http
      .put<Composant>(`${this.baseUrl}/${id}`, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  delete(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.http
      .delete<{ deleted: boolean; id: number }>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }
}
